import { render, staticRenderFns } from "./CompVideoQualification.vue?vue&type=template&id=49f249ef&scoped=true"
import script from "./CompVideoQualification.vue?vue&type=script&setup=true&lang=js"
export * from "./CompVideoQualification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompVideoQualification.vue?vue&type=style&index=0&id=49f249ef&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f249ef",
  null
  
)

export default component.exports